import { useEntity, QueryKeys, queryClient } from "@/api/core";
import { useAccountRelationships } from "@/api/relationships";
import { useAuth } from "@/contexts/auth/useAuth";
import { statusSchema } from "@/schemas";

interface UseStatusOpts {
  isEnabled?: boolean;
  refetch?: boolean;
}

function useStatus(statusId: string | null, opts: UseStatusOpts = {}) {
  const { refetch = false, isEnabled = true } = opts;

  const { queries } = queryClient.getDefaultOptions();

  const queryInfo = useEntity({
    enabled: !!statusId && isEnabled,
    endpoint: `/api/v1/statuses/${statusId}`,
    id: statusId,
    queryKey: QueryKeys.statuses.detail(statusId!),
    schema: statusSchema,
    staleTime: refetch ? 0 : 300000, // 5 minutes
    cacheTime: refetch ? 0 : queries?.cacheTime,
  });

  const { isLoggedIn } = useAuth();

  const { isLoading: isLoadingRelationships } = useAccountRelationships(
    [
      queryInfo.entity?.account?.id,
      queryInfo.entity?.reblog?.account?.id,
      queryInfo.entity?.quote?.account?.id,
    ].filter(Boolean) as string[],
  );

  return {
    ...queryInfo,
    status: queryInfo.entity,
    isLoading: queryInfo.isLoading || (isLoggedIn && isLoadingRelationships),
  };
}

export { useStatus };
